import { render, staticRenderFns } from "./peca.vue?vue&type=template&id=2bf89b7f&scoped=true&"
import script from "./peca.vue?vue&type=script&lang=ts&"
export * from "./peca.vue?vue&type=script&lang=ts&"
import style0 from "./peca.vue?vue&type=style&index=0&id=2bf89b7f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf89b7f",
  null
  
)

export default component.exports